import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/analytics'

const config = {
  apiKey: "AIzaSyBeQxlD7zTCruiAhzmQ629_FdVMXR00AnQ",
  authDomain: "norimemo-22ae2.firebaseapp.com",
  databaseURL: "https://norimemo-22ae2.firebaseio.com",
  projectId: "norimemo-22ae2",
  storageBucket: "norimemo-22ae2.appspot.com",
  messagingSenderId: "144605044490",
  appId: "1:144605044490:web:f6df47ce892ea73c4d64f3",
  measurementId: "G-YNGSZTBBYK"
}
  
export default firebase.initializeApp(config)
